import type { TransportRouteSummaryDto } from '../types/transport';

/**
 * The whole truck's freight in its own currency: the saved rate
 * (`transportRate`, what the transport form edits), else the legacy
 * `transportCost` of an older truck. Same rule as the backend
 * (transportService.getTransportAllocationCostInput). `null` = not known to
 * this reader (redacted for roles without transport costs) — never zero.
 */
export function truckFreightAmount(
  transport: Pick<TransportRouteSummaryDto, 'transportRate' | 'transportCost'>,
): number | null {
  if (transport.transportRate != null && Number.isFinite(transport.transportRate)) return transport.transportRate;
  if (transport.transportCost != null && Number.isFinite(transport.transportCost)) return transport.transportCost;
  return null;
}
